<div class="wrapper">
  <loading class="p-5">
    <ng-container i18n="@@front.logout.loading">Logging you out</ng-container>
  </loading>
</div>